export default "__VITE_ASSET__BSZXOrAD__"